import { SilverProvider } from "@/context/SilverContext";
import Atmosphere from "@/components/silver/layout/Atmosphere";
import Header from "@/components/silver/layout/Header";
import Footer from "@/components/silver/layout/Footer";
import SearchFab from "@/components/silver/layout/SearchFab";
import Hero from "@/components/silver/hero/Hero";
import MarketStory from "@/components/silver/story/MarketStory";
import PersonaCarousel from "@/components/silver/story/PersonaCarousel";
import FlowStory from "@/components/silver/story/FlowStory";
import LandingSearch from "@/components/silver/tool/LandingSearch";
import FinalCTA from "@/components/silver/proof/FinalCTA";
import { HowCalculatedDialog } from "@/components/silver/common/HowCalculatedDialog";

export default function SilverInitiative() {
  return (
    <SilverProvider>
      <Atmosphere />
      <Header />
      <main>
        <Hero />
        <MarketStory />
        <PersonaCarousel />
        <FlowStory />
        <LandingSearch />
        <FinalCTA />
      </main>
      <Footer />
      <SearchFab />
      <HowCalculatedDialog />
    </SilverProvider>
  );
}
